// libraries
import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import { STATIONS } from './MOCKS';

import EmptyIcon from '../../../../atoms/icons/EmptyIcon';

// components and mocks

interface Props {
  data?: {
    chargeBoxId: string;
    description: string;
  }[];
}

const StationsList: React.FC<Props> = ({ data = STATIONS }) => {
  return (
    <>
      <StationListHeader>{T('Stations')}:</StationListHeader>
      <StationListWrapper>
        {!data?.length ? (
          <div className='empty_card'>
            <EmptyIcon size={15} className={'empty_icon'} />
            <p>{T('There are no chargebox records')}</p>
          </div>
        ) : (
          data.map((station, index) => (
            <div className='card' key={index + 'station'}>
              <div className='item'>
                {' '}
                <p>{station.chargeBoxId}</p>
              </div>
              <div className='item'>
                {' '}
                <p>{station.description}</p>
              </div>
            </div>
          ))
        )}
      </StationListWrapper>
    </>
  );
};

export default StationsList;

const StationListHeader = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 10px;
`;

const StationListWrapper = styled.div`
  width: 50%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-left: 5px;

  .empty_card {
    background-color: #fff;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
    width: max-content;
    margin: 3px auto 3px 3px;
    border-radius: 8px;
    color: #555;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 10px 6px 0;

    p {
      margin: 0;
      font-size: 12px;
    }

    .empty_icon {
      margin: 0 10px;
    }
  }

  .card {
    background-color: #fff;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
    width: calc(100% - 25px);
    margin: 3px auto 3px 3px;
    border-radius: 8px;
    color: #555;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 10px 5px 10px 10px;

    .item {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      p {
        margin: 0;
        font-size: 11px;
      }

      img {
        width: 17px;
        height: 17px;
        margin-right: 5px;
      }
    }
  }
`;
